import React, { useEffect } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import Home from './pages/home/Home';
import CreateDocument from './pages/createDocument/CreateDocument';
import ReadDocument from './pages/readDocument/ReadDocument';
import Notice from './pages/notice/Notice';
import Training from './pages/training/Training';
import Settings from './pages/settings/Settings';
import { UseDrawer } from './shared/context';
import arrayMenu from './services/arrayMenus';
// sub rotas create document
import BodyCreateDocument from './components/layout/createDocument/importDocument/Body';
import BodyModifyDocument from './components/layout/createDocument/modifyDocument/Body';
import BodyValidationDocument from './components/layout/createDocument/validationDocument/Body';
import BodyPublishDocument from './components/layout/createDocument/publishDocument/Body';
import { ReportPage } from './pages/report/Report';

const RoutesExport = () => {
  const { setDrawerOptions } = UseDrawer();

  useEffect(() => {
    const indexView = parseInt(localStorage.getItem('@gedy:group'), 10);
    setDrawerOptions(arrayMenu[indexView - 1]);
    // eslint-disable-next-line
  }, []);

  return (
    <Routes>
      <Route path="/home" element={<Home />} />
      <Route path="/createDocument" element={<CreateDocument />}>
        <Route path="document" element={<BodyCreateDocument />} />
        <Route path="modify" element={<BodyModifyDocument />} />
        <Route path="validation" element={<BodyValidationDocument />} />
        <Route path="publish" element={<BodyPublishDocument />} />
        <Route path="*" element={<Navigate to="document" />} />
      </Route>
      <Route path="/readDocument" element={<ReadDocument />} />
      <Route path="/notice" element={<Notice />} />
      <Route path="/training" element={<Training />} />
      <Route path="/report" element={<ReportPage />} />
      <Route path="/settings" element={<Settings />} />
      <Route path="*" element={<Navigate to="/home" />} />
    </Routes>
  );
};

export default RoutesExport;
